/* eslint-disable react/display-name */
import React, { memo } from 'react';

import { SocialIconProps } from '../../types';
import { BadgeContainer } from './badgeContainer';

export const FacebookIcon = memo(({ 
    width = 40, 
    height = 40,
    fillColor = '#2F6F8C'
}: SocialIconProps) => {
    return (
        <BadgeContainer>
            <svg width={width} height={height} viewBox='0 0 16 29' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <path 
                    d='M10.1472 28.3234V15.6729H14.3926L15.0288 10.7424H10.1472V7.59814C10.1472 6.1667 10.5387 5.20018 12.5941 5.20018H15.2V0.795758C14.7474 0.734585 13.1936 0.600006 11.3951 0.600006C7.6269 0.600006 5.05765 2.90009 5.05765 7.10876V10.7424H0.800049V15.6729H5.05765V28.3234H10.1472Z' 
                    fill={fillColor} />
            </svg>
        </BadgeContainer>
    );
});
